// Warehouse Inbound Package Statuses
export const inboundStatuses = [
  { value: 'SHIPPED', label: 'Shipped' },
  { value: 'IN_WAREHOUSE', label: 'In Warehouse' },
  { value: 'CLAIMED', label: 'Claimed' },
  { value: 'PARTLY_CLAIMED', label: 'Partly Claimed' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
];

// Warehouse Outbound Package Statuses
export const outboundStatuses = [
  { value: 'READY_TO_DELIVERY', label: 'Ready to Delivery' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'PENDING_LABEL', label: 'Pending Label' },
  { value: 'LABEL_GENERATED', label: 'Label Generated' },
  { value: 'CLAIMED', label: 'Claimed' },
  { value: 'COMPLETED', label: 'Completed' },
];
